// extracted by mini-css-extract-plugin
export default {"button":"Cm-z","reviewSort":"Dm-z"};